import React from 'react';
import { Doughnut } from 'react-chartjs-2';
import 'chartjs-plugin-labels';
import PropTypes from 'prop-types';

export default function PieCharts(props) {
  const pieData = props.data;
  let data = {};
  data = {
    labels: [
      `Correct Answer- ${
        pieData.graphStats ? pieData.graphStats.correctQuestion : 0
      }`,
      `Partial Correct Answer- ${
        pieData.graphStats ? pieData.graphStats.partialCorrectQuestion : 0
      }`,
      `Not Attempted Question- ${
        pieData.graphStats ? pieData.graphStats.notAttemptQuestion : 0
      }`,
      `Incorrect Answer- ${
        pieData.graphStats ? pieData.graphStats.inCorrectQuestion : 0
      }`,
    ],
    datasets: [
      {
        data: [
          pieData.graphStats ? pieData.graphStats.correctQuestion : 0,
          pieData.graphStats ? pieData.graphStats.partialCorrectQuestion : 0,
          pieData.graphStats ? pieData.graphStats.notAttemptQuestion : 0,
          pieData.graphStats ? pieData.graphStats.inCorrectQuestion : 0,
        ],
        backgroundColor: ['#0FDE00', '#056AE4', '#FFA304', '#FF0000'],
        hoverBackgroundColor: ['#0FDE00', '#056AE4', '#FFA304', '#FF0000'],
      },
    ],
  };

  return (
    <div className="chart-container mb-20">
      <Doughnut
        data={data}
        options={{
          maintainAspectRatio: false,
          responsive: true,
          legend: {
            display: true,
            position: 'bottom',
            align: 'start',
            fullWidth: true,
            labels: {
              boxWidth: 15,
            },
          },
          plugins: {
            labels: {
              render: 'percentage',
              fontColor: 'white',
            },
          },
          tooltips: {
            enabled: true,
            callbacks: {
              label: function (tooltipItems) {
                return data.labels[tooltipItems.index];
              },
            },
          },
        }}
      />
    </div>
  );
}
PieCharts.propTypes = {
  data: PropTypes.object,
};
